/**
 * It's originally from commands & it's called EXIT
 * @alias EXIT
 */
export const StopApplication = 'Web.Application.Exit';
export interface StopApplication {
	type: typeof StopApplication;
}
